import React from 'react';
import { Grid, TextField } from '@mui/material';
import { FormikProps } from 'formik';
import { AddressDto } from '../../Models';
import { styled } from '@mui/material/styles';
import Provinces from '../../../../common/dropdowns/Provinces';

interface PostalFormProps {
  formik: FormikProps<AddressDto>;
}

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const PostalForm: React.FC<PostalFormProps> = ({ formik }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="postalAddress"
          name="postalAddress"
          label="Postal address"
          value={formik.values.postalAddress}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.postalAddress && Boolean(formik.errors.postalAddress)}
          helperText={formik.touched.postalAddress && formik.errors.postalAddress}
        />
      </Grid>
      
      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="postalCity"
          name="postalCity"
          label="City"
          value={formik.values.postalCity}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.postalCity && Boolean(formik.errors.postalCity)}
          helperText={formik.touched.postalCity && formik.errors.postalCity}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Provinces
          formik={formik}
          name="postalProvinceId"
          value={formik.values.postalProvinceId}
          error={Boolean(formik.touched.postalProvinceId && formik.errors.postalProvinceId)}
          touched={formik.touched.postalProvinceId}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <StyledTextField
          fullWidth
          id="postalCode"
          name="postalCode"
          label="Postal Code"
          value={formik.values.postalCode}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.postalCode && Boolean(formik.errors.postalCode)}
          helperText={formik.touched.postalCode && formik.errors.postalCode}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(PostalForm);